import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateClassSectionExternalRefDto {
  @ApiPropertyOptional({ type: 'string', description: 'Code de la section' })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: 'Libellé de la section' })
  @IsOptional()
  @IsString()
  label?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({ description: 'Parcours éducatifs', type: [String] })
  @IsOptional()
  track?: string[]

  @ApiPropertyOptional({ description: 'Codes des niveaux compatibles', type: [String] })
  @IsOptional()
  validLevelCodes?: string[]

  @ApiPropertyOptional({ description: 'Codes des diplômes compatibles', type: [String] })
  @IsOptional()
  validDegreeTypes?: string[]
}
